module.exports = "<p>\n  events works!\n</p>\n"